import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  base: '/robotdemo',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('@/pages/Home/Index')
    },
    {
      path: '/question',
      name: 'Question',
      component: () => import('@/pages/Question/Index')
    },
    {
      path: '/contact-us',
      name: 'ContactUs',
      component: () => import('@/pages/ContactUs/Index')
    },
    {
      path: '/result',
      name: 'Result',
      component: () => import('@/pages/Result/Index')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js